import {apiClient} from "./apiClient";
import {LoginRequest, LoginResponse} from "../interfaces/interfaces";

export const login = async (loginRequest: LoginRequest): Promise<LoginResponse> => {
    const response = await apiClient.post(
        "/auth/login", loginRequest
    );
    return response.data;
}
